// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `span.internal-link {
  color: #1976d2;
  border-bottom: 1px dashed #1976d2;
  position: relative;
}

span.internal-link:hover:before,
span.internal-link:hover:after {
  display: block;
}

span.internal-link:before {
  font-family: sans-serif;
  font-size: 12px;
  line-height: 16px;
  color: white;
  padding: 4px 8px;
  position: absolute;
  background-color: #262b33;
  bottom: calc(100% + 2px);
  left: 50%;
  transform: translateX(-50%);
  display: none;
  width: 100px;
  text-align: center;
  border-radius: 3px;
}

span.internal-link-post:before {
  content: 'Internal link. Post id:' attr(data-post-id);
}

span.internal-link-example:before {
  content: 'Internal link. Example · id:' attr(data-example-id);
}

span.internal-link-resume-example:before {
  content: 'Internal link. Resume example · id:' attr(data-example-id);
}

span.internal-link-cover-letter-example:before {
  content: 'Internal link. Cover letter example · id:' attr(data-example-id);
}

span.internal-link-landing:before {
  content: 'Internal link. Page type: ' attr(data-link-type);
}

span.internal-link-resume-example-category:before {
  content: 'Resume example category · id: ' attr(data-resource-id);
}

span.internal-link-cover-letter-example-category:before {
  content: 'Cover letter example category · id: ' attr(data-resource-id);
}

span.internal-link-resume-template-category:before {
  content: 'Resume template category · id: ' attr(data-resource-id);
}

span.internal-link-cover-letter-template-category:before {
  content: 'Cover letter template category · id: ' attr(data-resource-id);
}

span.internal-link-blog-category:before {
  content: 'Blog category · id: ' attr(data-resource-id);
}

span.internal-link:after {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 2px;
  bottom: calc(100% - 4px);
  position: absolute;
  background-color: #262b33;
  left: 50%;
  transform: rotate(45deg) translateX(-50%);
  display: none;
}

span.internal-link--selected {
  background: rgba(31, 177, 255, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/plugins/internal-link/styles.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":["span.internal-link {\n  color: #1976d2;\n  border-bottom: 1px dashed #1976d2;\n  position: relative;\n}\n\nspan.internal-link:hover:before,\nspan.internal-link:hover:after {\n  display: block;\n}\n\nspan.internal-link:before {\n  font-family: sans-serif;\n  font-size: 12px;\n  line-height: 16px;\n  color: white;\n  padding: 4px 8px;\n  position: absolute;\n  background-color: #262b33;\n  bottom: calc(100% + 2px);\n  left: 50%;\n  transform: translateX(-50%);\n  display: none;\n  width: 100px;\n  text-align: center;\n  border-radius: 3px;\n}\n\nspan.internal-link-post:before {\n  content: 'Internal link. Post id:' attr(data-post-id);\n}\n\nspan.internal-link-example:before {\n  content: 'Internal link. Example · id:' attr(data-example-id);\n}\n\nspan.internal-link-resume-example:before {\n  content: 'Internal link. Resume example · id:' attr(data-example-id);\n}\n\nspan.internal-link-cover-letter-example:before {\n  content: 'Internal link. Cover letter example · id:' attr(data-example-id);\n}\n\nspan.internal-link-landing:before {\n  content: 'Internal link. Page type: ' attr(data-link-type);\n}\n\nspan.internal-link-resume-example-category:before {\n  content: 'Resume example category · id: ' attr(data-resource-id);\n}\n\nspan.internal-link-cover-letter-example-category:before {\n  content: 'Cover letter example category · id: ' attr(data-resource-id);\n}\n\nspan.internal-link-resume-template-category:before {\n  content: 'Resume template category · id: ' attr(data-resource-id);\n}\n\nspan.internal-link-cover-letter-template-category:before {\n  content: 'Cover letter template category · id: ' attr(data-resource-id);\n}\n\nspan.internal-link-blog-category:before {\n  content: 'Blog category · id: ' attr(data-resource-id);\n}\n\nspan.internal-link:after {\n  content: '';\n  width: 8px;\n  height: 8px;\n  border-radius: 2px;\n  bottom: calc(100% - 4px);\n  position: absolute;\n  background-color: #262b33;\n  left: 50%;\n  transform: rotate(45deg) translateX(-50%);\n  display: none;\n}\n\nspan.internal-link--selected {\n  background: rgba(31, 177, 255, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
